import palette from "src/theme/palette";

export const RENEWAL_WARNING_CHIP_STYLE = {
  backgroundColorPath: ["warning", "200"],
  textColorPath: ["warning", "700"]
};

export const ACTIVE_CHIP_STYLE = {
  backgroundColorPath: ["success", "200"],
  textColorPath: ["success", "600"]
};

export const RENEWAL_PAST_CHIP_STYLE = {
  backgroundColorPath: ["error", "200"],
  textColorPath: ["error", "700"]
};

export const RENEWAL_WARNING_DAYS_THRESHOLD = 90;

export const GO_LIVE_WARNING_DAYS_THRESHOLD = 90;

export const TEAM_ROLES = {
  csm: "Engagement Manager",
  solutionArchitect: "Solutions Architect",
  executiveSponsor: "Executive Sponsor"
};

export const PRODUCTS_TABLE_COLUMNS = [
  { field: "name", headerName: "Product" }
];

// Key order = legend order and bar stacking order (bottom → top), per Figma.
export const CHANNEL_META = {
  voice_inbound: {
    label: "Voice inbound",
    color: palette.success[500],
    tooltip: "All engaged calls"
  },
  voice_outbound: {
    label: "Outbound",
    color: palette.secondary[400],
    tooltip: "All answered calls and answering machine"
  },
  chat: {
    label: "Chat",
    color: palette.info[600],
    tooltip: "All engaged conversations"
  }
};

export const CHANNEL_ORDER = Object.keys(CHANNEL_META);

export const USAGE_BAR_COLORS = {
  track: palette.system[300]
};

export const USAGE_BAR_MIN_SEGMENT_PX = 18;

export const GO_LIVE_BANNER_TEXT = "Go-live date is not set yet, ";
export const GO_LIVE_BANNER_LINK = "set up in Salesforce";
export const GO_LIVE_SET_UP_LINK = "Set up";

export const buildSalesforceAssetsUrl = (salesforceAccountId) =>
  `https://airbudtechnologies.lightning.force.com/lightning/r/Account/${salesforceAccountId}/related/Assets/view`;

export const ALL_CHANNELS_USAGE_LABEL = "All channels usage";

export const QUOTA_NOT_STARTED_SUBTITLE = "Once the term will be active we will track the subscription activity here.";

export const QUOTA_TERM_TOOLTIP = "The term used to calculate usage out of contracted quota (Annually)";

export const UNLIMITED_LIMIT_LABEL = "Unlimited";
export const UNLIMITED_PLAN_SUBTITLE = "Account allowed unlimited interactions through their plan";
export const buildPlanSubtitle = (limit) => `Account allowed ${limit.toLocaleString()} interactions through their plan`;

// LaunchDarkly flag "usage-over-time" (camelCased by the react SDK).
export const USAGE_OVER_TIME_FEATURE_FLAG = "usageOverTime";
export const USAGE_OVER_TIME_TITLE = "Usage over time";
export const USAGE_OVER_TIME_EMPTY_TITLE = "Nothing here yet.";
export const USAGE_OVER_TIME_EMPTY_SUBTITLE = "Monthly usage will appear here once the term has activity.";
export const USAGE_OVER_TIME_ERROR_TEXT = "Failed to load usage over time.";
export const USAGE_OVER_TIME_MAX_MONTHS = 12;
export const buildUsageOverTimeFootnote = (maxMonths) =>
  `Monthly engaged interactions, showing the last ${maxMonths} months of the current term`;
export const INTERACTIONS_SUFFIX = "Interactions";
export const SKILLS_TOOLTIP_LABEL = "Interactions by skill";
export const SKILLS_OTHER_LABEL = "Other";
export const MAX_TOOLTIP_SKILLS = 5;
export const MONTH_LABEL_FORMAT = "MMM";
export const TERM_DATE_FORMAT = "MMM D, YYYY";
export const MONTH_RANGE_FORMAT = "MMM YYYY";

export const SKILLS_TOOLTIP_STYLE = {
  width: 253,
  padding: "12px 14px",
  borderRadius: "4px"
};
